import gql from "graphql-tag";

export const QUESTIONARY_PARSAMS = gql`
  query properties(
    $address: AddressHash!
    $page: Int!
    $perPage: Int
    $sort: String!
    $sortOrder: String = "desc"
    $marketStatus: String = "all" #'off_market, on_market,
    $filters: [SearchHash!]
    $mapFilters: MapFiltersInput
    $skipUpdateMap: Boolean = false
  ) {
    properties(
      address: $address
      page: $page
      sort: $sort
      sortOrder: $sortOrder
      marketStatus: $marketStatus
      filters: $filters
      perPage: $perPage
      mapFilters: $mapFilters
      skipUpdateMap: $skipUpdateMap
    ) {
      clusteredEntities @skip(if: $skipUpdateMap) {
        label
        # radius
        cluster
        position {
          lat
          lng
        }
      }
      pinEntities @skip(if: $skipUpdateMap) {
        id
        listPrice
        onMarket
        bedrooms
        bathsFull
        livingArea
        fullAddress
        street
        daysOnMarket
        city
        likelihoodToSell
        likelihoodToSellDescription
        isInteresting
        position {
          lat
          lng
        }
        photos {
          id
          image
          preview2x
        }
      }
      entities {
        id
        listPrice
        bedrooms
        coordinates
        bathsFull
        city
        street
        onMarket
        likelihoodToSell
        likelihoodToSellDescription
        isInteresting
        source
        status
        fullAddress
        daysOnMarket
        livingArea
        photos {
          id
          image
          preview2x
        }
      }
      pagination {
        totalItems
        totalPages
        currentPage
        perPage
      }
      address {
        placeId
        description
        type
        #   coordinates
      }
      tabHeaders {
        onMarket
        offMarket
        offMarketClaimed
      }
    }
  }
`;
